import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { Server } from '@wajeez/wajeez.microservices';
import { FieldContent } from './FieldContent';

interface FieldSelectContentProps {
  label: string | undefined;
  value: Server.ISelectOption[] | undefined;
}

export const FieldSelectContent = ({
  label,
  value,
}: FieldSelectContentProps) => {
  return (
    <div className="w-full">
      <div className="text-[16px] font-medium">
        <ReturnTranslatedText
          text={`inputs.labels.${label}`}
          origintext={label}
        />
      </div>
      <div className="mt-1 p-2 grid grid-cols-2 gap-4 rounded bg-white border">
        {value?.map((v) => {
          return <FieldContent label={v.label} value={v.value} />;
        })}
      </div>
    </div>
  );
};
